export default __webpack_public_path__ + "static/media/7641727 (1).8cca3ea1.png";